import { useRouter } from 'next/router';
import { Col, Grid, Image, Row, Typography } from 'antd';
import { ButtonBorderKomunitasDetailArtikel } from 'src/components/Forms/Button';
import JoinKomunitasDetailArtikelContainerWeb from './indexweb';
import classes from './index.module.less';
const JoinKomunitasDetailArtikelContainer = (props: any) => {
  const router = useRouter();
  const {
    xs
  } = Grid.useBreakpoint();
  const typeArtikel = props.artikel.type;
  return <div>
			{xs ? <div className={classes['page-body-wrap']}>
						<div className="container" style={{
        marginTop: '40px',
        marginBottom: '40px'
      }}>
							<div className={typeArtikel === 'pre-pregnancy' ? classes.pageheropre : typeArtikel === 'pregnancy' ? classes.pagehero : classes.pageheropost}>
								<Row>
									<Col md={14} sm={{
              span: 14,
              order: 1
            }} xs={{
              span: 24,
              order: 1
            }} lg={14} xl={14} style={{
              alignContent: 'center',
              justifyContent: 'center'
            }}>
										{typeArtikel === 'pre-pregnancy' ? <div style={{
                marginLeft: xs ? '20px' : '80px',
                marginRight: '20px'
              }}>
												<p className={classes.title1}>
													Saling Dukung dan Berbagi Cerita di Komunitas Program Hamil
												</p>
												<Typography className={classes.paragraph1}>
													Gabung komunitas Hallobumil dan temukan support, edukasi dan inspirasi di setiap
													langkah perjuanganmu
												</Typography>
												<div onClick={() => router.push('/komunitas')} style={{
                  marginTop: '10px',
                  marginBottom: '40px'
                }}>
													<ButtonBorderKomunitasDetailArtikel text={'Gabung Komunitas Program Hamil'}></ButtonBorderKomunitasDetailArtikel>
												</div>
											</div> : typeArtikel === 'pregnancy' ? <div style={{
                marginLeft: xs ? '20px' : '80px',
                marginRight: '20px',
                marginTop: '20px'
              }}>
												<p className={classes.title}>
													Nikmati Perjalanan Kehamilan Bersama Bumil Lainnya
												</p>
												<Typography className={classes.paragraph}>
													Gabung dan temui teman, tips, dan cerita inspiratif di komunitas Hallobumil
													untuk lewati masa hamil dengan penuh dukungan
												</Typography>
												<div onClick={() => router.push('/komunitas')} style={{
                  marginTop: '10px',
                  marginBottom: '40px'
                }}>
													<ButtonBorderKomunitasDetailArtikel text={'Gabung Komunitas Kehamilan'}></ButtonBorderKomunitasDetailArtikel>
												</div>
											</div> : <div style={{
                marginLeft: xs ? '20px' : '80px',
                marginRight: '20px'
              }}>
												<p className={classes.title1}>Tumbuh Bersama di 1000 Hari Pertama Si Kecil</p>
												<Typography className={classes.paragraph1}>
													Komunitas hangat untuk dapatkan tips, cerita inspiratif, dan teman baru pada
													1000 hari pertama si kecil bersama Hallobumil
												</Typography>
												<div onClick={() => router.push('/komunitas')} style={{
                  marginTop: '10px',
                  marginBottom: '40px'
                }}>
													<ButtonBorderKomunitasDetailArtikel text={'Gabung Komunitas Tumbuh Kembang'}></ButtonBorderKomunitasDetailArtikel>
												</div>
											</div>}
									</Col>
									<Col md={10} sm={{
              span: 10,
              order: 2
            }} xs={{
              span: 24,
              order: 2
            }} lg={10} xl={10} style={{
              textAlign: 'center',
              alignContent: 'center',
              justifyContent: 'center'
            }}>
										<div style={{
                textAlign: 'center',
                alignContent: 'center',
                justifyContent: 'center',
                marginLeft: '10px',
                marginRight: '10px'
              }}>
											{typeArtikel === 'pre-pregnancy' ? <Image src="/images/default/prepregnancy.svg" alt="image" preview={false} /> : typeArtikel === 'pregnancy' ? <Image src="/images/default/pregnancy.svg" alt="image" preview={false} /> : <Image src="/images/default/postpregnancy.svg" alt="image" preview={false} />}
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</div> : <JoinKomunitasDetailArtikelContainerWeb {...props} />}
		</div>;
};
export default JoinKomunitasDetailArtikelContainer;